import $ from 'jquery';
jQuery.noConflict();

export function updateDealOfTheDayRootmenu() {
    var dt = new Date();
    var dt = dt.getTime();
    var $rootmenuDotd = $('.rootmenu a[href*="/dotd/"], .verticalmenu02 a[href*="/dotd/"]');
    var $rootmenuDotdLink = $rootmenuDotd.attr('href');
    if (typeof $rootmenuDotdLink != 'undefined') {
        $rootmenuDotd.attr('href', $rootmenuDotdLink + '?cachebuster=' + dt);
    }
}

export function headerFunctions() {
    $('.login').on('click', function(event) {
        event.stopPropagation();
        event.preventDefault();
        // Only load the login modal if customer isn't already logged in 
        if (!$(this).find('.greeting-text').hasClass('logged-in')) {
            var $classicAccount = new window.cfAccount();
            var classicAccount = new cfAccount();
            classicAccount.openModal(modalSuccess);

            function modalSuccess() {
                location.reload();
                return false;      
            }
        }

        if ($(this).hasClass('account')) {
            $(this).toggleClass("selected");
            $('span.cart.sidebar').removeClass("selected");
            $('span.cart.sidebar div.block-cart').hide();
            // $('.scroll-search-container').hide();
            if ($('span.cart.sidebar').hasClass('selected')) {
                $('.wrapper-overlay-dark').show();
                $('.wrapper-overlay').hide();
            } else {
                $('.wrapper-overlay-dark').hide();
            }
        }
        
    });

    $('.pulldown').on('click', function(event) {
        event.stopPropagation();
    });
    //end account pulldown
    // cart pulldown for new responsive design
    $('span.cart.sidebar').on('click', function (event) {
        $('body').removeClass('noscroll');
        event.stopPropagation();
        $(this).toggleClass('selected');
        $('span.login.account > a').removeClass('selected');
        $('span.cart.sidebar div.block-cart').slideToggle('fast');
        $('.pulldown').hide();
        // $('.scroll-search-container').hide();
        $('.modal-mobile-signin').hide();
        if ($(this).hasClass('selected')) {
            $('.rootmenu-mobile').removeClass('open');
            $('.wrapper-overlay').hide();
            $('.header.is-mobile').next().addClass('hidden');
        }
        if ($('span.login.account > a, span.cart.sidebar').hasClass('selected')) {
            $('.wrapper-overlay-dark').show();
        } else {
            $('.wrapper-overlay-dark').hide();
        }
        return false;
    });

    $('span.cart.sidebar div.block-cart').on('click', function(event) {
        event.stopPropagation();
    });

    $('.scroll-search-button').on('click', function(e) {
        $('.scroll-search-container').toggleClass('d-lg-block');
        $('span.cart.sidebar .block-cart').hide();
        $('.modal-mobile-signin').hide();
        e.stopPropagation();
    });

    $('html').on('click', function() {
        $('span.login.account > a').removeClass('selected');
        $('.pulldown').hide();
        $('span.cart.sidebar').removeClass('selected');
        $('span.cart.sidebar div.block-cart').hide();
        $('.wrapper-overlay-dark').hide();
        $('.modal-mobile-signin').hide();

        if ($('.rootmenu').hasClass('hidden')) {
            $('body').removeClass('noscroll');
        }
    });

    $('.modal-mobile-signin .minimize-x').on('click', function() {
        $('.modal-mobile-signin').hide();
        $('.wrapper-overlay-dark').hide();
    });
}
